import { render, staticRenderFns } from "./Signature.vue?vue&type=template&id=c8e0c562"
import script from "./Signature.ts?vue&type=script&lang=ts&external"
export * from "./Signature.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports